import Vue from 'vue';
import Router from 'vue-router';

// 引入页面组件
const Home = () => import('@/views/Home.vue');
const ProductDetail = () => import('@/views/product/Detail.vue');
const CaseList = () => import('@/views/case/List.vue');
const CaseDetail = () => import('@/views/case/Detail.vue');
const About = () => import('@/views/About.vue');
const Contact = () => import('@/views/Contact.vue');
const NotFound = () => import('@/views/404.vue');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { x: 0, y: 0 };
  },
  routes: [
    // 前端页面路由
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/product',
      name: 'ProductList',
      component: () => import('@/views/product/List.vue'),
      meta: {
        title: '产品中心'
      }
    },
    {
      path: '/product/:id',
      name: 'ProductDetail',
      component: ProductDetail,
      props: true,
      meta: {
        title: '产品详情'
      }
    },
    {
      path: '/case',
      name: 'CaseList',
      component: CaseList,
      meta: {
        title: '成功案例'
      }
    },
    {
      path: '/case/:id',
      name: 'CaseDetail',
      component: CaseDetail,
      props: true,
      meta: {
        title: '案例详情'
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About,
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact,
      meta: {
        title: '联系我们'
      }
    },    
    // 登录页面
    // 重定向到前端首页，避免访问不存在的页面
    {
      path: '/login',
      redirect: '/'
    },
    // 重定向到前端首页
    {
      path: '/admin',
      redirect: '/'
    },
    
    // 404页面
    {
      path: '*',
      name: 'NotFound',
      component: NotFound,
      meta: {
        title: '404 - 页面不存在'
      }
    }
  ]
});

// 全局前置守卫，用于设置页面标题和权限控制
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || '造纸新材料门户';
  
  // 权限控制（这里简化处理，实际项目中需要更完善的权限验证）
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查是否登录（这里简化为检查localStorage中的token）
    const token = localStorage.getItem('token');
    if (!token) {
      // 未登录，重定向到登录页面
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      // 已登录，继续导航
      next();
    }
  } else {
    // 不需要权限的页面，直接导航
    next();
  }
});

export default router;